var map = {
	"./ProductsWarehouses.js": "7776",
	"./adminPanel.js": "4f6b",
	"./bunk.js": "a86a",
	"./buyReadyProducts.js": "9df9",
	"./cacher.js": "378e",
	"./cashierStationary.js": "0baa",
	"./categoryService.js": "0b42",
	"./citizenship.js": "5976",
	"./conResources.js": "3b4f",
	"./contractWarehouses.js": "8960",
	"./contracts.js": "cf06",
	"./costTransaction.js": "781f",
	"./couriers.js": "d2a2",
	"./debts.js": "480a",
	"./defects.js": "9f72",
	"./doctorCabinet.js": "87a9",
	"./documentType.js": "e3fe",
	"./hospital.js": "3bff",
	"./invoices.js": "f4d8",
	"./invoicesInsurance.js": "d76f",
	"./laboratoryCabinet.js": "a2d4",
	"./letterhead.js": "3c95",
	"./moving.js": "9c38",
	"./nationality.js": "c314",
	"./neededPills.js": "1a58",
	"./normaCost.js": "80b2",
	"./normaLaboratory.js": "218d",
	"./nurseOffice.js": "993c",
	"./nurseOfficePhy.js": "3099",
	"./order.js": "3697",
	"./orderServiceTerm.js": "ba27",
	"./organization.js": "6833",
	"./patient.js": "76c1",
	"./patientAge.js": "d9cc",
	"./patientAgeReport.js": "9ec9",
	"./patientHistory.js": "f430",
	"./patientRoom.js": "4e56",
	"./payment.js": "35d4",
	"./paymentBonus.js": "af45",
	"./personal.js": "a0e5",
	"./printHistory.js": "7198",
	"./printedForm.js": "9ac2",
	"./productResidues.js": "afcd",
	"./remainderReport.js": "2b51",
	"./reportCategory.js": "9628",
	"./reportLimit.js": "76e4",
	"./requirement.js": "eb7b",
	"./resources.js": "74b7",
	"./roles.js": "2d8c",
	"./schedule.js": "c407",
	"./schedulesCabinet.js": "e407",
	"./scores.js": "1ea0",
	"./services.js": "5e68",
	"./settings.js": "e880",
	"./settingsCategory.js": "dbe1",
	"./shipments.js": "ae46",
	"./stockBunk.js": "6437",
	"./stocksSryaWarehouses copy.js": "7674",
	"./stocksSryaWarehouses.js": "f5a1",
	"./stocksWarehouses.js": "7c15",
	"./tag.js": "a7ba",
	"./transactionScores.js": "5b0e",
	"./users.js": "bc70",
	"./writeOff.js": "4ab2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9aa3";